module.exports = __webpack_public_path__ + "media/assets/images/marker-developer-570304ade4b9672382e391e6fb39cdd9.svg";